export const VOUCHER_LIST_ACTION = "VOUCHER_LIST_ACTION";
export const VOUCHER_LIST_SUCCESS = "VOUCHER_LIST_SUCCESS";
export const VOUCHER_IMPORT_ACTION = "VOUCHER_IMPORT_ACTION";
export const VOUCHER_IMPORT_SUCCESS = "VOUCHER_IMPORT_SUCCESS";
export const VOUCHER_IMPORT_FAILD = "VOUCHER_IMPORT_FAILD";
export const VOUCHER_EXPORT_ACTION = "VOUCHER_EXPORT_ACTION";
export const VOUCHER_EXPORT_SUCCESS = "VOUCHER_EXPORT_SUCCESS";
export const VOUCHER_CREATE_ACTION = "VOUCHER_CREATE_ACTION";

export const VOUCHER_GET_ITEM_ACTION = "VOUCHER_GET_ITEM_ACTION";
export const VOUCHER_GET_ITEM_SUCCESS = "VOUCHER_GET_ITEM_SUCCESS";
export const VOUCHER_GET_HISTORY_ACTION = "VOUCHER_GET_HISTORY_ACTION";
export const VOUCHER_GET_HISTORY_SUCCESS = "VOUCHER_GET_HISTORY_SUCCESS";
export const VOUCHER_UPDATE_ACTION = "VOUCHER_UPDATE_ACTION";
export const VOUCHER_UPDATE_SUCCESS = "VOUCHER_UPDATE_SUCCESS";
export const VOUCHER_USED_ACTION = "VOUCHER_USED_ACTION";
export const VOUCHER_USED_SUCCESS = "VOUCHER_USED_SUCCESS";
export const VOUCHER_CHECK_ACTION = "VOUCHER_CHECK_ACTION";
export const VOUCHER_CHECK_SUCCESS = "VOUCHER_CHECK_SUCCESS";
export const VOUCHER_CHECK_FAIL = "VOUCHER_CHECK_FAIL";
export const VOUCHER_RESET = "VOUCHER_RESET";
export const VOUCHER_FAIL = "VOUCHER_FAIL";

export const VOUCHER_EXPORT_EXCEL_ACTION = "VOUCHER_EXPORT_EXCEL_ACTION";
export const VOUCHER_EXPORT_EXCEL_FAIL = "VOUCHER_EXPORT_EXCEL_FAIL";
export const VOUCHER_EXPORT_EXCEL_SUCCESS = "VOUCHER_EXPORT_EXCEL_SUCCESS";
